import {
  FlowItem,
  FlowItemParameterMetadata,
  ParametersForm,
} from '../../../shared/model/flow.types';
import { FlowItemService } from '../../../shared/service/service.types';
import { getParameterValueFromForm } from '../../../shared/util/flow-parameter.util';
import { BeaconPaintingData } from '../model/beacon-painting-data';

/**
 * Get parameter metadata from form values for paint items
 * This determines which parameters should be shown based on current form state
 */
export const getPaintingParameterMetadataFromForm = (
  flowItemService: FlowItemService,
  form: ParametersForm,
  options: BeaconPaintingData.GetParameterMetadataFromFormOptions = {}
): FlowItemParameterMetadata[] => {
  const { forceApproach, forceDepart, forceIncludeTags, forceExcludeRefs } =
    options;

  let tags: BeaconPaintingData.FlowItemParameterTag[] = [];
  let excludedParams = [...(forceExcludeRefs ?? [])];

  // Check if approach is enabled
  const isApproach =
    forceApproach !== undefined
      ? forceApproach
      : getParameterValueFromForm<boolean>(
          form,
          BeaconPaintingData.FlowItemParameterRef.APPROACH
        );

  // Check if depart is enabled
  const isDepart =
    forceDepart !== undefined
      ? forceDepart
      : getParameterValueFromForm<number>(
          form,
          BeaconPaintingData.FlowItemParameterRef.DEPART
        );

  if (isApproach) {
    tags.push(BeaconPaintingData.FlowItemParameterTag.APPROACH);
  }

  if (isDepart) {
    tags.push(BeaconPaintingData.FlowItemParameterTag.DEPART);
  }

  // Add any forced tags
  if (forceIncludeTags) {
    tags = tags.concat(forceIncludeTags);
  }

  // Get unique tags
  const uniqueTags = Array.from(new Set(tags));

  let params = flowItemService.getParametersMetadataByTags(
    BeaconPaintingData.FlowItemRef.PAINT,
    form,
    uniqueTags as string[],
    true
  );

  if (isDepart) {
    excludedParams = excludedParams.concat([
      BeaconPaintingData.FlowItemParameterRef.TRAVEL_SPEED,
    ]);
  }

  // Filter out excluded parameters
  params = params.filter(
    (param) =>
      !excludedParams.includes(
        param.ref as BeaconPaintingData.FlowItemParameterRef
      )
  );

  return params;
};

/**
 * Check if a flow item is a paint item of a specific type
 */
export const isPaintType = (
  flowItem: FlowItem,
  type: BeaconPaintingData.PaintTypeEnum
): boolean => {
  if (flowItem.ref !== BeaconPaintingData.FlowItemRef.PAINT) {
    return false;
  }

  const idx = flowItem.parameters.findIndex(
    (p) =>
      p.ref === BeaconPaintingData.FlowItemParameterRef.PAINT_TYPE &&
      p.value === type
  );

  return idx !== -1;
};
